"use strict";

exports.__esModule = true;
exports.formatMetricTableData = void 0;
var _Utils = require("../../../Utils");
var _DataTableToolbar = require("../../Core/DataTable/DataTableToolbar");
var _DataTableContextMenu = require("../DataTable/DataTableContextMenu");
var formatMetricTableData = exports.formatMetricTableData = function formatMetricTableData(columns, data, timeFormat) {
  if (timeFormat === _DataTableToolbar.DOWNLOAD_HOUR_MINUTES_SECONDS_FORMAT) {
    return (0, _DataTableContextMenu.getFormattedData)(columns, data == null ? void 0 : data.map(function (row) {
      var _row$datesArray;
      var _row = JSON.parse(JSON.stringify(row));
      (_row$datesArray = _row.datesArray) == null || _row$datesArray.forEach(function (date) {
        _row[date] = (0, _Utils.formatDuration)(_row[date]);
        _row[date + ".type"] = "string";
      });
      return _row;
    }));
  }
  return (0, _DataTableContextMenu.getFormattedData)(columns, data);
};